import axios from 'axios'
document.querySelectorAll('[data-load-more]').forEach( loader => {

  const request = {
    pageSize: loader.getAttribute('data-load-more-size'),
    postType: loader.getAttribute('data-load-more-type'),
    seite: 1
  }
  const requestDefaultKeys = Object.keys(request)

  const triggers = loader.querySelectorAll('[data-load-more-trigger]')
  const holder = loader.querySelector('[data-load-more-holder]')
  const bigTeaser = loader.querySelector('[data-filter-first]')
  const bigTeaserId = loader.getAttribute('data-skip-post-id')
  const noResults = loader.querySelector('[data-filter-no-results]')

  const hasAnyFilterActive = () => {
    for (const key in request) {
      if (!requestDefaultKeys.includes(key)) {
        return true
      }
    }
    return false
  }

  const updateNoResults = () => {
    if (holder.children.length === 0) {
      noResults.classList.remove('is-hidden')
    } else {
      noResults.classList.add('is-hidden')
    }
  }

  const loadMore = async (resetHolder = false) => {
    if (resetHolder) {
      request.seite = 1
    }

    if (bigTeaser) {

      console.log(hasAnyFilterActive(), request)

      if (hasAnyFilterActive()) {
        bigTeaser.classList.add('hidden')
        request.skipPostId = bigTeaserId
      } else {
        bigTeaser.classList.remove('hidden')
        request.skipPostId = null
      }
    }

    const response = await axios.get(window.php_vars.restUrl + 'glunz/v1/loadmore', {
      params: request
    })

    if (resetHolder) {
      holder.innerHTML = ''
    }


    response.data.posts.forEach( post => {
      let parent = document.createElement('div')
      parent.innerHTML = post
      holder.appendChild(parent.querySelector('a,div'))
    })

    triggers.forEach(elm => elm.classList.toggle('is-hidden', response.data.isLastPage))

    updateNoResults()
  }


  window.addEventListener('filter:change', e => {

    // filter unused keys should be removed from request
    Object.keys(request).forEach( key => {
      if (!requestDefaultKeys.includes(key) && !(key in e.detail.state)) {
        delete request[key]
      }
    })

    Object.entries(e.detail.state).forEach( ([key, value]) => {
      request[key] = value
    })
    console.log('filter changed, loading more with new request', request, e.detail.state)

    loadMore(e.detail.recentlyChanged)
  })

})
